/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_And_Select_User_PlaceholderInputs */

const en_search_and_select_user_placeholder = /** @type {(inputs: Search_And_Select_User_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search and select a user...`)
};

const es_search_and_select_user_placeholder = /** @type {(inputs: Search_And_Select_User_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Busca y selecciona un usuario...`)
};

/**
* | output |
* | --- |
* | "Search and select a user..." |
*
* @param {Search_And_Select_User_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_and_select_user_placeholder = /** @type {((inputs?: Search_And_Select_User_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_And_Select_User_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_and_select_user_placeholder(inputs)
	return es_search_and_select_user_placeholder(inputs)
});